import { createSelector } from 'reselect';
import {
  getAllBrandfolders,
  getBrandfolderWithGenericFileSections,
  getLoadingBrandfolder,
  getSelectedBrandfolder
} from './brandfolder';
import {
  getAllCollections,
  getCollectionWithGenericFileSections,
  getLoadingCollection,
  getSelectedCollection
} from './collection';
import { getAllOrganizations } from './organization';

export const getAllContainers = createSelector(
  getAllBrandfolders,
  getAllCollections,
  getAllOrganizations,
  (brandfolders, collections) =>
    brandfolders && collections && [...brandfolders, ...collections.map(collection => mapCollection(collection, brandfolders))]
);

function mapCollection(collection) {
  return {
    ...collection,
    attributes: {
      ...collection.attributes,
      name: `${collection.attributes.name} (collection)`
    }
  }
}

// TODO: create a new slice of state to manage the selected container ~PP
export const getSelectedContainer = createSelector(
  getSelectedBrandfolder,
  getSelectedCollection,
  (selectedBrandfolder, selectedCollection) => {
    return selectedBrandfolder || selectedCollection;
  }
);

// TODO: create a new slice of state to manage the selected container ~PP
export const getSelectedContainerWithGenericFileSections = createSelector(
  getSelectedContainer,
  getBrandfolderWithGenericFileSections,
  getCollectionWithGenericFileSections,
  (selectedContainer, brandfolder, collection) => {
    if (!selectedContainer) return null;
    return brandfolder && brandfolder.id === selectedContainer.id ? brandfolder : collection
  }
)

export const getLoadingContainer = createSelector(
  getLoadingBrandfolder,
  getLoadingCollection,
  (loadingBrandfolder, loadingCollection) => loadingBrandfolder || loadingCollection
)



// WEBPACK FOOTER //
// ./src/selectors/container.js